import { AdminForgotPassReq } from '../../redux/slices/admin.slice'
import ButtonSpinner from '../../components/common/ButtonSpinner'
import { Card, Form, Button, Row, Col, InputGroup } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Images from '../../assets/js/images'
import { FiMail } from "react-icons/fi"
import { Link } from 'react-router-dom'
import React, { Fragment } from 'react'

const ForgotPassword = () => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const { mloading } = useSelector(state => state.AdminSlice)

    const handleSubmit = (e) => {
        e.preventDefault()
        const form = new FormData(e.target)
        const formData = Object.fromEntries(form)
        dispatch(AdminForgotPassReq({ data: formData }))
    }

    return (
        <Fragment>
            <div className="wrapper">
                <div className="authentication-forgot d-flex align-items-center justify-content-center">
                    <div className="container">
                        <Row className='align-items-center'>
                            <Col lg={6} className='text-center'>
                                <img src={Images?.NewLogo} alt="logo icon" style={{ width: '200px' }} className='mx-auto' />
                                <div style={{ backgroundImage: `url(${Images?.BgLogin})`, backgroundSize: 'cover' }} className='text-center'>
                                    <div style={{ minHeight: '450px' }} className='position-relative'>
                                        <img src={Images?.Car} className='position-absolute start-0' style={{ bottom: '70px', width: '500px' }} />
                                    </div>
                                </div>
                            </Col>
                            <Col lg={6}>
                                <Row>
                                    <Col sm={10} md={8} className='mx-auto'>
                                        <Card className="login-box">
                                            <Card.Body className="card-body">
                                                <div className="p-4 rounded">
                                                    <h4 className="font-weight-bold text-center mb-4">{t('forgot_password')}?</h4>
                                                    <div className="form-body">
                                                        <Form onSubmit={handleSubmit}>
                                                            <InputGroup className="mb-3">
                                                                <InputGroup.Text><FiMail /></InputGroup.Text>
                                                                <Form.Control type="text" name="email" placeholder={t('enter_email')} />
                                                            </InputGroup>
                                                            <Form.Group className="d-grid gap-2">
                                                                <Button type="submit" className="btn btn-primary btn-sm m-0">{t('get_link')} {mloading && <ButtonSpinner />}</Button>
                                                                <Link to="/login" className="btn btn-white btn-sm m-0"><i className='bx bx-arrow-back m-0'></i>{t('back_login')}</Link>
                                                            </Form.Group>
                                                        </Form>
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default ForgotPassword
